import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './LegalPages.css';

const About = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const el = document.querySelector(location.hash);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [location]);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <header className="legal-header">
          <h1>About The Interconnector</h1>
          <p className="legal-subtitle">Connecting communities, building relationships</p>
        </header>

        <div className="legal-content">
          <section>
            <h2>Our Mission</h2>
            <p>
              To help people connect meaningfully with those they can truly vibe and thrive with. We believe that having enriching connections within communities that resonate with us makes us more confident, secure, understood, and ultimately more tolerant and open to new people and experiences.
            </p>
          </section>

          <section>
            <h2>Our Story</h2>
            <p>
              The Interconnector was born out of the idea that we need to get out of our echo chambers. James (founder) began running 'Chatter Chamber' events, but soon realised that what we were actually lacking was a chance to connect with people on a meaningful level with those we can vibe and thrive with.
            </p>
            <p>
              Ironically, perhaps what is needed is more 'echo chambers' –  but the sort that resonate and inspire, that make us feel more confident and secure, more understood and connected. Having meaningful and enriching connections could, perhaps, actually make us more tolerant, more open and more accepting to new people.
            </p>
            <p>
              At first, James and a few Cambridge and Southampton grads began working with a community of people going through divorce. It seemed to work well. Since then, James decided to learn to code and, along with the emerging wave of AI as an ever-increasing assistant and chief coder, developed this website to get things going. Enjoy!
            </p>
          </section>

          <section>
            <h2>How It Works</h2>
            <p>
              The Interconnector uses an intelligent matching system to connect you with like-minded people in your area. Here's how:
            </p>
            <ol>
              <li><strong>Join Communities:</strong> Choose communities that match your interests or life situation</li>
              <li><strong>Create Your Profile:</strong> Tell us about yourself and what you're looking for</li>
              <li><strong>Get Matched:</strong> Our AI system finds compatible people in your area</li>
              <li><strong>Start Connecting:</strong> Chat, meet up, and build meaningful relationships</li>
            </ol>
          </section>

          <section>
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>🤝 Authentic Connections</h3>
                <p>We believe in fostering genuine relationships, not superficial networking.</p>
              </div>
              <div className="value-item">
                <h3>🏘️ Community First</h3>
                <p>Local communities are the foundation of meaningful social connections.</p>
              </div>
              <div className="value-item">
                <h3>🔒 Privacy & Safety</h3>
                <p>Your safety and privacy are our top priorities in everything we do.</p>
              </div>
              <div className="value-item">
                <h3>🌍 Inclusivity</h3>
                <p>Everyone deserves to find their place and people, regardless of background.</p>
              </div>
            </div>
          </section>

          <section id="our-team">
            <h2>Our Team</h2>
            <div className="team-grid">
              <div className="team-member">
                <img
                  className="team-member-avatar"
                  src="https://storage.googleapis.com/inter-profile-pics/0d148416-2e8e-4f42-8656-3d2140a68dc9.jpg"
                  alt="James Peachey"
                />
                <h3 className="team-member-name">James Peachey</h3>
                <p className="team-member-role">Startupper Founder</p>
                <p>
                  James founded The Interconnector after first running 'Chatter Chamber', meal events designed to spark real conversation between strangers. That experiment in bringing people with different backgrounds together revealed a bigger need: a way for any community to find and match its own members meaningfully, not just at a one-off dinner. So James taught himself to code and, working closely with AI as a coding partner, built The Interconnector into a platform that lets communities create their own matching apps. Along the way he's studied and lived in Cambridge, Edinburgh and at Goldsmiths in London, and spent time in Berlin doing creative performance work. He's currently trialling the first live Interconnector Groups, including Edinburgh Fringers, continuing to iterate on the platform in public.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2>Our Impact</h2>
            <p>
              Starting with our Divorce Club Interconnector Group, we've seen the power of meaningful connections firsthand. Here's what our early members have shared:
            </p>
            <div className="values-grid">
              <div className="value-item">
                <p><em>"The founder was really friendly, professional and efficient to help us get things set up. Was a really easy process that matched me well with others."</em></p>
                <small>– DC Connect Member, May 2021</small>
              </div>
              <div className="value-item">
                <p><em>"A really good  service and helps find people in similar circumstances and hopefully lead to friendship. It was good to meet new people and share our stories."</em></p>
                <small>– DC Connect Member, May 2021</small>
              </div>
              <div className="value-item">
                <p><em>"Very strange how alike our circumstances are!"</em></p>
                <small>– DC Connect Member, September 2021</small>
              </div>
              <div className="value-item">
                <p><em>"This was a great way to connect on a one to one basis & also to make new friends with similar issues."</em></p>
                <small>– DC Connect Member, September 2021</small>
              </div>
            </div>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              Have questions or want to learn more? We'd love to hear from you.
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> james@theinterconnector.com</p>
              <p><strong>Address:</strong> Various pet sits, Edinburgh and London</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;